import { Link } from "react-router-dom";

export default function Lookbook() {
    const images = [
        "https://images.unsplash.com/photo-1764697907425-62696b280b31?w=1400&q=85",
        "https://images.unsplash.com/photo-1764697907711-12831f7e08ed?w=1400&q=85",
        "https://images.unsplash.com/photo-1542406775-ade58c52d2e4?w=1400&q=85",
        "https://images.unsplash.com/photo-1611601679380-d28dc63ed40c?w=1400&q=85",
        "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?w=1400&q=85",
        "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=1400&q=85",
    ];

    return (
        <div className="max-w-7xl mx-auto px-6 lg:px-10" data-testid="lookbook-page">
            <p className="font-mono-ui text-[#857C72]">Lookbook</p>
            <h1 className="font-display text-5xl md:text-6xl mt-2">SS25 / Westside.</h1>
            <p className="mt-4 text-[#6B645C] max-w-xl">An editorial mood for the new drop. Captured on the streets, in the studios, under sundown.</p>
            <div className="mt-10 grid md:grid-cols-2 gap-4 lg:gap-6">
                {images.map((img, i) => (
                    <div key={i} className={`relative rounded-[28px] overflow-hidden border border-[#E7DED2] shadow-[0_18px_44px_rgba(18,18,20,0.14)] ${i % 3 === 0 ? "aspect-[4/5]" : "aspect-[3/4]"}`}>
                        <img src={img} alt="lookbook" className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                ))}
            </div>
            <div className="text-center mt-12">
                <Link to="/shop" className="dw-btn-primary px-7 py-3 font-mono-ui">Shop the looks</Link>
            </div>
            <div className="h-24" />
        </div>
    );
}
